import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'cta';
  fullWidth?: boolean;
  icon?: ReactNode;
}

export default function Button({ 
  children, 
  variant = 'primary', 
  fullWidth = false, 
  icon,
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = 'font-bold py-4 px-6 rounded-full transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2';
  
  const variants = {
    primary: 'bg-[#0A5FFF] hover:bg-[#0850D6] text-white',
    secondary: 'bg-white hover:bg-gray-50 text-[#1F2937] border-2 border-gray-300',
    success: 'bg-[#00C853] hover:bg-[#00A844] text-white',
    cta: 'bg-[#FF8F00] hover:bg-[#E67E00] text-white shadow-lg transform hover:scale-105'
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {icon && <span className="text-xl">{icon}</span>}
      {children}
    </button>
  );
}
